// en.js
export default {
  lang: {
    // 会员码页面
    home: 'HOME',
    normalMember: 'Ordinary Member',
    vipMember: 'VIP',
    superVip: 'Super VIP',
    deluxeClue: 'Deluxe Clue',
    earnedPoints: 'Available Points',
    membershipCode: 'Member Code',
    expire: 'Expires',
    accumulatedConsumption: 'Cumulative consumption',
    spending: 'Spending',
    todaySpending: 'again or spending',
    upgradeLevel: 'on the same day can maintain',
    stayLevel: '可保級',
    yuan: '元',
    
    // 积分页面
    pointsFlow: 'Points Flow',
    availableIntegral: 'Available Points',
    integralDetail: 'Points Detail',
    ofwhich: 'Of which',
    points: 'points',
    will: 'will expire at',
    expired: 'expire at',

    // 历史优惠券
    historicalCoupon: 'Historical Coupon',
    all: 'All',
    used: 'Used',
    alreadyExpired: 'Expired',

    // 购物记录
    orderLists: 'Purchase History',
    originOrderCode: '原訂單號',
    actualPayment: 'Actual Payment',
    orderGoodsName: 'Product Name',
    pleaseEnterGoodsName: 'Please enter the product name',
    orderType: 'Order Type',
    order: 'Consumption order',
    specialOrder: 'Special Order',
    refundOrder: 'Refund Order',
    orderDate: 'Order Date',
    nearlyAMonth: 'Last month',
    nearlyThreeMonths: 'Last 3 months',
    nearlySixMonths: 'Nearly 6 months',
    startDate: 'Start time',
    endDate: 'End time',
    orderSource: 'Order Source',

    // 优惠券
    myCoupon: 'My coupon',
    couponDetail: 'Coupon detail',
    couponList: 'Coupon lists',
    couponClaim: 'Claim coupon',
    couponCode: 'Coupon Code',
    please: 'Please use by',
    beforeUse: '',
    usedFor: 'Available Platforms',
    useInstructions: 'Instructions for use', 

    //按钮 
    ok: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    reset: 'Reset',
    query: 'Query',
    confirmedUse: 'Use',
    claim: 'Claim',
    // 提示
    copySuccess: 'Copy successfully',
    copyFail: 'Copy failed',
    noMore: 'No more',
    confirmUseMsg: 'The coupon will not be refundable after use, so please check if you want to use it now？',
    useSuccessfully: 'Use sucessfully！',
    receiveSuccess: 'Claim sucessfully！',
    // 标题
    tip: 'Tips',
    filter: 'Filter',
    selectStartDate: 'Select start date',
    selectEndDate: 'Select end date',
    chinaOnline: 'MC eshop',
    chinaOffline: 'MC store',
    hongkongOnline: 'HK/MO store',
    hongKongOffline: 'HK/MO eshop',
    usePlatform: '指定优惠券可用的平台',
  }
}
